import { render } from "./LocationResidence.vue?vue&type=template&id=2167b580&scoped=true"
import script from "./LocationResidence.vue?vue&type=script&lang=js"
export * from "./LocationResidence.vue?vue&type=script&lang=js"

import "./LocationResidence.vue?vue&type=style&index=0&id=2167b580&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Latitude E5570\\Desktop\\MES DOSSIERS\\WEB-SITE-DEXTER\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2167b580"]])

export default __exports__